import { useSyncExternalStore } from "react";

import { getStoredValue, setStoredValue } from "src/hooks/use-persisted-state";

// Global per user, like the nav's open state, rather than per workspace.
const CLASSIC_NAV_KEY = "nav:classic";

const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  // Another tab switching navigation switches this one too.
  window.addEventListener("storage", listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", listener);
  };
};

const getSnapshot = () =>
  getStoredValue<boolean>(CLASSIC_NAV_KEY, false) === true;

/** The viewer's choice of the navigation from before the product tabs, which only matters while they're flagged into the tabs. */
export const useClassicNavPreference = () => {
  const isClassicNav = useSyncExternalStore(subscribe, getSnapshot);

  const setIsClassicNav = (isClassic: boolean) => {
    setStoredValue(CLASSIC_NAV_KEY, isClassic);
    for (const listener of listeners) listener();
  };

  return { isClassicNav, setIsClassicNav };
};
